// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root__Km8Te","heading":"Alert_heading__2HCNX"};